<template>
  <div class="hideBoxs">
    <!--   关注   -->
    <focus :item="item"></focus>
    <!--   函询   -->
    <mail :item="item" :type="type"></mail>
    <!--   交流   -->
    <im :item="item"></im>
    <!--   查看详细   -->
    <openDetail :item="item"></openDetail>
  </div>
</template>

<script>
import { mapState } from "vuex"
export default {
  name: "hideBox",
  components: {
    focus: () => import('./button/focus'),
    mail: () => import('./button/mail'),
    im: () => import('./button/im'),
    openDetail: () => import('./button/openDetail'),
  },
  props: {
    item: {
      type: Object
    },
    type: {
      type: [Number,String] // 1 工队 2 工程 3 工人 4 临时用工 5 工种报价 6劳务用工
    }
  },
  data() {
    return {}
  },
  filters: {},
  watch: {},
  computed: {
    ...mapState({
      userNo: state => state.user.no,
      companyNo: state => state.user.companyNo
    })
  },
  methods: {},
  created() {},
  mounted() {}
}
</script>

<style lang="scss" scoped>
  .hideBoxs{
    position: absolute;
    width: 100%;
    outline: 1px solid #b79255;
    display: flex;
    /deep/ .button{
      flex:1;
      height: 40px;
      line-height: 40px;
      color: #ffffff;
      background: #b79255;
      border: 1px solid #b79255;
      border-top: none;
      margin-right: 1px;

      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      cursor: pointer;
      span{
        display: inline-block;
      }
      img {
        vertical-align: middle;
        margin: -2px 4px 0 0 ;
      }
      &:last-child{
        margin-right: 0;
      }
    }
  }
</style>
